 /* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import { PDFDocument, values } from "pdf-lib";

import { obtenerDetalleOrdenCompra, obtenerOrdenCompra } from '../../../../API/Compras/Ordenes/OrdenesComprasRequests';
import { logoPPFBase64 } from '../../../RRHH/Evaluacion/Imgs';
import { OrdenesComprasReporteLang } from "./OrdenesComprasLang";
import { getLabel } from '../../../../Base/Services/Language/LanguageService';
import QRCode from 'qrcode';
import { getLocalDateString } from '../../../../Base/Services/FechasService';
import { getDateString } from '../../../../Base/Services/Moment/Luxon';
import { formatDateWithTime, formatNumber3Dec, formatNumberDecimal } from '../../../../Base/Services/FormatTemplate';
import { Dialog } from 'primereact/dialog';
import Loader from '../../../../Base/Components/Loader/Loader';
import { Toast } from 'primereact/toast';
import { getRequisaPR } from '../../../../API/Compras/Requisas/PurchaseRequests';
import { getFirmaPersonal } from '../../../../API/Firmas/FirmasRequests';
import { getPersonal } from '../../../../API/RRHH/Personal/PersonalRequests';
import { getUsuariosActivos } from '../../../../API/IT/Usuarios/UsersRequests';


const OrdenesComprasReporte = ({showReporte, setShowReporte, selected, setSelected, lenguaje, getInfo = () => {}}) => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState([]);
  const [pdfUrl2, setPdfUrl2] = useState([]);
  const [pdfUrlCombinado, setPdfUrlCombinado] = useState(null);

  const obtenerInformacion = async () => {
    const numOrden = selected.NumeroOrden || selected[0].PurchaseOrder
    setLoading(true);
    const tempoOrden = await obtenerOrdenCompra(numOrden);
    if(tempoOrden){
      const tempoDetalle = await obtenerDetalleOrdenCompra(tempoOrden[0]?.IdPurchaseOrder);
      const encabezado = tempoDetalle.filter(det => ![3327].includes(det.IdStatus))
      const descuento = tempoDetalle.reduce((total, value) => total + value.Descuento, 0);
      
      const subTotal = tempoDetalle.reduce((total, value) => total + value.Subtotal, 0);
      
      // Agrupar por `PurchaseRequest`
      const groupedPurchaseRequests = tempoDetalle.reduce((acc, detalle) => {
        if (!acc[detalle.PurchaseRequest]) {
          acc[detalle.PurchaseRequest] = []; // Inicializar grupo si no existe
        }
        acc[detalle.PurchaseRequest].push(detalle);
        return acc;
      }, {});

      const groupedIdPRP = [...new Set(tempoDetalle.map(item => item?.IdPurchaseRequest))].join(',');

      // Generar un string con las agrupaciones (sin incluir números)
      const purchaseRequests = Object.keys(groupedPurchaseRequests).join(', ');


      const PR = await getRequisaPR(groupedIdPRP)

      const groupedPR = PR.reduce((acc, requisicion) => {
        if (!acc[requisicion.IdPurchaseRequest]) {
            acc[requisicion.IdPurchaseRequest] = [];
        }
        acc[requisicion.IdPurchaseRequest].push(requisicion);
        return acc;
      }, {});

      generarPDF(encabezado[0], tempoDetalle, descuento, purchaseRequests, subTotal);

      generarPDFRequisa(groupedPR)
    }
    setLoading(false);
  }

  const calcularCantidadTotal = (listadoDetalles) => {
    let cantidadTot = 0;
    listadoDetalles.forEach((detalle) => {
      cantidadTot += detalle.QtyOrdered;
    });
    return cantidadTot;
  };

  const calcularCantidadProductos = (listadoDetalles) => {
    const idProductsSet = new Set();
    listadoDetalles.forEach((detalle) => {
      idProductsSet.add(detalle.IdComponent);
    });
    return idProductsSet.size;
  };

  //REPORTE ORDEN DE COMPRAS
  const generarPDF = async (data, listadoDetalles, descuento, purchaseRequests, subTotal) => {
    let CodigoQR 
    QRCode.toDataURL(`${data.PurchaseOrder}`, { errorCorrectionLevel: 'Q' }, (err, url) => { CodigoQR = url })

    const monedas = [
      ...new Set(listadoDetalles.map((detalle) => detalle.CurrencySymbol)),
    ];

    const cantidadTot = calcularCantidadTotal(listadoDetalles);
    const cantidadProductos = calcularCantidadProductos(listadoDetalles);

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [35, 85, 30, 80],

      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              {
                image: logoPPFBase64?.logo,
                width: 150,
                margin: [4, 10, -10, -10],
              },

              [
                {
                  text: "PRIDE PERFORMANCE FABRICS S.A. DE C.V.",
                  style: "titulo2",
                  margin: [-5, 30, 0, 0],
                  width: 350,
                },
                {
                  text: "ZONA LIBRE PRIDE PERFORMANCE FABRICS, S.A. DE C.V.  KM 19.5 CARRETERA A OCCIDENTE,LA ACEQUIA, NACO, QUIMISTAN, SANTA BARBARA, HONDURAS.",
                  style: "titulo",
                  margin: [-5, 5, 0, 0],
                  width: 350,
                },
              ],

              [
                {
                  text: [
                    {
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "TituloReporte",
                        lenguaje
                      )}\n`,
                      style: "numeroDoc",
                    },
                    {
                      text: `${data?.PurchaseOrder || ""}`,
                      style: "numeroDoc1",
                    },
                  ],
                  width: 100,
                  margin: [0, 30, 0, 0],
                },
              ],
            ],
          },
        ];
      },

      footer:(currentPage,pageCount) => {
        return{
          margin: [20, 0, 20, 0],
          table:{
            widths: ['*','15%'],
                body:[
                [
                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"original",lenguaje)}` + "  " +
                    `${getLabel(OrdenesComprasReporteLang,"copia",lenguaje)}` + "  " +
                    `${getLabel(OrdenesComprasReporteLang,"copia2",lenguaje)}`,
                    style:"textBody3"
                  },
                  {
                    image: CodigoQR,
                    width: 45,
                    margin: [0, 0, 0, 0],
                    alignment: "right",
                    rowSpan:2,
                  },
                ],

                [
                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"textFinal",lenguaje)}`,
                    style:"textBody3"
                  },

                  {
                  }
                ],

                [
                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"request",lenguaje)}`+`${purchaseRequests}`,
                    style:"textBody3"
                  },
                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"Pagina",lenguaje)} ${currentPage} / ${pageCount}`,
                    style:"textBody2"
                  }
                ],
              ]
          },
          layout: 'noBorders'
        }
      },

      content: [
        //Datos Inicailes
        {
          columns: [
            {
              margin: [0, 10, 0, 3],
              table: {
                widths: ["80%", "20%"],
                body: [
                  [
                    {
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "toShip",
                        lenguaje
                      )} Zoli Pride Performance Fabrics KM 19.5 Carretera a Occidente, La`,
                      border: [false, false, false, false],
                      style: "infoGeneral",
                    },
                    {
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "fecha",
                        lenguaje
                      )} ${getDateString(new Date())}`,
                      border: [false, false, false, false],
                      style: "infoGeneralRTN",
                    },
                  ],
                  [
                    {
                      text: `Acequia, Naco, Quimistán, Santa Bárbara, Honduras, C.A`,
                      border: [false, false, false, false],
                      style: "infoGeneral",
                    },
                    {
                      text: `RTN: 05019013550285`,
                      border: [false, false, false, false],
                      style: "infoGeneralRTN",
                    },
                  ],
                ],
              },
            },
          ],
        },

        //Tabla Inicial Vendor, Ship To
        {
          table: {
            margin: [0, 0, 0, 10],
            widths: ["*", "0.02%", "*"],
            body: [
              [
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "proveedor",
                    lenguaje
                  )}`,
                  style: "subtitle",
                  border: [true, true, true, false],
                },
                {
                  text: ``,
                  style: "subtitle",
                  border: [true, false, true, false],
                },
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "envioA",
                    lenguaje
                  )}`,
                  style: "subtitle",
                  border: [false, true, true, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea vertical
            },
            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
            vLineColor: function (i) {
              return "#aaa"; // Color de las líneas verticales
            },
          },
        },

        {
          table: {
            margin: [0, 15, 0, 0],
            widths: ["*", "0.02%", "*"],
            body: [
              //NOMBRE
              [
                {
                  text: [
                    {
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "nombre",
                        lenguaje
                      )}${data?.Vendor || ""}`,
                      style: "subtitle2",
                    },
                  ],
                  // style: "subtitle2",
                  margin: [10, 4, 0, 0],
                  border: [true, false, false, false],
                },
                {
                  text: ``,
                  style: "subtitle",
                  border: [true, false, true, false],
                },
                {
                  text: [
                    {
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "nombre",
                        lenguaje
                      )}${data?.CustomerName || ""}`,
                      style: "subtitle2",
                    },
                  ],
                  // style: "subtitle2",
                  margin: [10, 4, 0, 0],
                  border: [true, false, true, false],
                },
              ],

              //ATTN
              [
                {
                  text: [
                    {
                      text: `Attn: ${data?.Contact || ""}`,
                      style: "subtitle2",
                    },
                  ],
                  // style: "subtitle2",
                  margin: [15, 0, 0, 0],
                  border: [true, false, false, false],
                },
                {
                  text: ``,
                  style: "subtitle",
                  border: [true, false, true, false],
                },
                {
                  text: [
                    {
                      text: `Attn: ${data?.AgentName || ""}`,
                      style: "subtitle2",
                    },
                  ],
                  // style: "subtitle2",
                  margin: [15, 0, 0, 0],
                  border: [true, false, true, false],
                },
              ],

              //ADDRESS
              [
                {
                  text: [
                    {
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "direccion",
                        lenguaje
                      )}${data?.Address || ""}`,
                      style: "subtitle2",
                    },
                  ],
                  // style: "subtitle2",
                  margin: [0, 4, 0, 0],
                  border: [true, false, false, false],
                },
                {
                  text: ``,
                  style: "subtitle",
                  border: [true, false, true, false],
                },
                {
                  text: [
                    {
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "direccion",
                        lenguaje
                      )}${data?.AddressShipTo || ""}`,
                      style: "subtitle2",
                    },
                  ],
                  // style: "subtitle2",
                  margin: [0, 4, 0, 0],
                  border: [true, false, true, false],
                },
              ],

              //TELEFONO
              [
                {
                  text: [
                    {
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "telefono",
                        lenguaje
                      )}${data?.Tel || ""}`,
                      style: "subtitle2",
                    },
                  ],
                  // style: "subtitle2",
                  margin: [15, 8, 0, 0],
                  border: [true, false, false, true],
                },
                {
                  text: ``,
                  style: "subtitle",
                  border: [true, false, true, false],
                },
                {
                  text: [
                    {
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "telefono",
                        lenguaje
                      )}${data?.TelSupplier || "+504 2625-4400"}`,
                      style: "subtitle2",
                    },
                  ],
                  // style: "subtitle2",
                  margin: [15, 8, 0, 0],
                  border: [true, false, true, true],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea vertical
            },
            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
            vLineColor: function (i) {
              return "#aaa"; // Color de las líneas verticales
            },
          },
        },

        //TABLA PRINCIPAL
        {
          margin: [0, 10, 0, 0],
          table: {
            widths: ["*", 24, 50, 190, 34, "*", 32, "*"],
            body: [
              [
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "cantidad",
                    lenguaje
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "unidad",
                    lenguaje
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "codigo",
                    lenguaje
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "producto",
                    lenguaje
                  )}`,
                  style: "header",
                },
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "precio",
                    lenguaje
                  )}`,
                  style: "header",
                },
                { text: `SubTotal`, style: "header" },
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "descuento",
                    lenguaje
                  )}`,
                  style: "header",
                },
                { text: `Total`, style: "header" },
              ],
              ...listadoDetalles.map((d) => [
                {
                  text: formatNumberDecimal(`${d.QtyOrdered || ""}`),
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: `${d.UnitSimbol || "" }`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: `${d.CodigoProducto || ""}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: `${d.NombreProducto}`,
                  style: "textBody3",
                  border: [false, false, false, false],
                },
                {
                  text: formatNumber3Dec(`${d.UnitPrice}`),
                  style: "textBody2",
                  border: [false, false, false, false],
                },
                {
                  text: formatNumber3Dec(`${d.Subtotal}`),
                  style: "textBody2",
                  border: [false, false, false, false],
                },
                {
                  text: formatNumber3Dec(`${d.Descuento}`),
                  style: "textBody2",
                  border: [false, false, false, false],
                },
                {
                  text: formatNumber3Dec(`${d.Subtotal}`),
                  style: "textBody2",
                  border: [false, false, false, false],
                },
              ]),
            ],
          },
          // layout: 'lightHorizontalLines'
        },

        {
          margin: [3, 3, 0, 5],
          table: {
            widths: [30, 25, 90, 147, 35, 35, 35, 70],
            body: [
              [
                {
                  text: formatNumberDecimal(`${cantidadTot}`),
                  style: "headerr",
                  border: [false, true, false, false],
                  colSpan: 8,
                  margin: [13, 0, 0, 0],
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },

            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
          },
        },

        //TABLA TOTALES
        {
          table: {
            margin: [0, 0, 0, 10],
            widths: ["70%", "*", "*"],
            body: [
              [
                {
                  text: ``,
                  style: "subtitle",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "subtitle",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "subtitle",
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea vertical
            },
            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
            vLineColor: function (i) {
              return "#aaa"; // Color de las líneas verticales
            },
          },
        },

        {
          table: {
            margin: [0, 15, 0, 0],
            widths: ["70%", "*", "*"], // Asegúrate de que haya espacio suficiente para la tercera columna
            body: [
              // Fila 1: Términos de Pago y Subtotal
              [
                {
                  text: ``,
                  style: "subtitle2",
                  border: [false, false, false, false],
                },
                { text: "SubTotal", style: "textTotales", margin:[0,2,0,0] },
                {
                  table: {
                    widths: ["auto", "*"],
                    body: [
                      [
                        { text: `${monedas}`, style: "textTotales2", border: [false, false, false, false] },
                        { text: `${formatNumber3Dec(subTotal)}`, style: "textTotales", alignment: "right", border: [false, false, false, false] },
                      ],
                    ],
                  },
                  layout: "noBorders",
                },
              ],             
              // Fila 2: Términos Inco y Descuento
              [
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "terminosPago",
                    lenguaje
                  )}${data?.VendorTerms || ""}`,
                  style: "subtitle2",
                  border: [false, false, false, false],
                },
                { text:  `${getLabel(
                  OrdenesComprasReporteLang,
                  "desc",
                  lenguaje
                )}`, style: "textTotales",margin:[0,2,0,0] },
                {
                  table: {
                    widths: ["auto", "*"],
                    body: [
                      [
                        { text: `${monedas}`, style: "textTotales2", border: [false, false, false, false] },
                        { text: `${formatNumber3Dec(data?.Descuento)}`, style: "textTotales", alignment: "right", border: [false, false, false, false] },
                      ],
                    ],
                  },
                  layout: "noBorders",
                },
              ],
              // Fila 3: Comentario e ISV
              [
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "terminosInco",
                    lenguaje
                  )} ${data?.TermName || ""}`,
                  style: "subtitle2",
                  border: [false, false, false, false],
                },
                { text:`${getLabel(
                    OrdenesComprasReporteLang,
                    "isv",
                    lenguaje
                  )}`, style: "textTotales", margin:[0,2,0,0]},
                {
                  table: {
                    widths: ["auto", "*"],
                    body: [
                      [
                        { text: `${monedas}`, style: "textTotales2", border: [false, false, false, false] },
                        { text: `${formatNumber3Dec(data?.Tax)}`, style: "textTotales", alignment: "right", border: [false, false, false, false] },
                      ],
                    ],
                  },
                  layout: "noBorders",
                },
              ],
              // Fila 4: Fletes
              [
                { text: `${getLabel(
                  OrdenesComprasReporteLang,
                  "comentario",
                  lenguaje
                )} ${data?.Description || ""}`,style:"subtitle2", border: [false, false, false, false] },
                { text:`${getLabel(
                  OrdenesComprasReporteLang,
                  "fletes",
                  lenguaje
                )}`, style: "textTotales",margin:[0,2,0,0] },
                {
                  table: {
                    widths: ["auto", "*"],
                    body: [
                      [
                        { text: `${monedas}`, style: "textTotales2", border: [false, false, false, false] },
                        { 
                          text: data?.Freights != null ? `${formatNumber3Dec(data?.Freights)}` : "0.000", 
                          style: "textTotales", 
                          alignment: "right",
                           border: [false, false, false, false] },
                      ],
                    ],
                  },
                  layout: "noBorders",
                },
              ],
              // Fila 5: Otros
              [
                { text: "", border: [false, false, false, false] },
                { text:`${getLabel(
                  OrdenesComprasReporteLang,
                  "otros",
                  lenguaje
                )}`, style: "textTotales",margin:[0,2,0,0] },
                {
                  table: {
                    widths: ["auto", "*"],
                    body: [
                      [
                        { text: `${monedas}`, style: "textTotales2", border: [false, false, false, false] },
                        { 
                          text: data?.Otros != null ? `${formatNumber3Dec(data?.Otros)}` : "0.000", 
                          style: "textTotales", 
                          alignment: "right", 
                          border: [false, false, false, false] },
                      ],
                    ],
                  },
                  layout: "noBorders",
                },
              ],
              // Fila 6: Total
              [
                { text: "", border: [false, false, false, false] },
                { text: "Total", style: "textTotales",margin:[0,2,0,0] },
                {
                  table: {
                    widths: ["auto", "*"],
                    body: [
                      [
                        { text: `${monedas}`, style: "textTotales2", border: [false, false, false, false] },
                        { text: `${formatNumber3Dec(subTotal + data.Tax - data.Descuento + data.Otros)}`, style: "textTotales", alignment: "right", border: [false, false, false, false] },
                      ],
                    ],
                  },
                  layout: "noBorders",
                },
              ],
            ],
          },
        },

        //Firma
        {
          columns: [
            {
              margin: [0, 100, 0, 0],

              table: {
                widths: [170, "*", 170],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      text: "",
                      width: [100],
                    },
                    {
                      border: [false, true, false, false],
                      text: `${getLabel(
                        OrdenesComprasReporteLang,
                        "deptoCompras",
                        lenguaje
                      )}`,
                      style: "firmas",
                    },
                    {
                      border: [false, false, false, false],
                      text: "",
                      width: [120],
                    },
                  ],
                ],
              },
            },
          ],
        },
      ],

      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        titulo: {
          fontSize: 9,
          // margin: [0, 50, 0, 0],
          // bold: true,
          alignment: "justify",
        },
        titulo2: {
          fontSize: 10,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        requisa: {
          fontSize: 15,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        numeroDoc: {
          fontSize: 14,
          bold: true,
          alignment: "center",
        },
        numeroDoc1: {
          fontSize: 13,
          // bold: true,
          alignment: "center",
        },
        subtitle: {
          fontSize: 8,
          bold: true,
          // alignment: "center",
        },
        subtitle2: {
          fontSize: 8,
          // bold: true,
        },
        infoGeneral: {
          fontSize: 8,
          margin: [-5, 0, 0, 0],
          // bold: true,
          // alignment: 'justify'
        },
        infoGeneralRTN: {
          fontSize: 8,
          margin: [-5, 0, 0, 0],
          // bold: true,
          alignment: "right",
        },
        infoProveedor: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
        },
        header: {
          fontSize: 6.5,
          alignment: "center",
          bold: true,
        },
        headerr: {
          fontSize: 7,
          margin: [-5, 0, 0, 0],
        },
        textBody1: {
          fontSize: 7.5,
          alignment: "center",
          // lineHeight: 2
        },
        textBody2: {
          fontSize: 7.5,
          alignment: "right",
          // lineHeight: 2
        },
        textBody3: {
          fontSize: 7.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textBody4: {
          fontSize: 8.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textTotales: {
          bold: true,
          fontSize: 7.5,
          alignment: "right",
        },
        textTotales2: {
          bold: true,
          fontSize: 7.5,
          alignment: "left",
        },
        textCentrado: {
          fontSize: 7.5,
          alignment: "center",
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: "center",
          lineHeight: 1,
        },
        footer: {
          fontSize: 7.5,
          alignment: "left",
          margin: [30, 0, 5, 0],
        },
      },
    };

    const doc = pdfMake.createPdf(docDefinition);

    doc.getDataUrl((url) =>{
      setPdfUrl([url])
    })
  };

  //SUMAR CANTIDAD RECIBIDA REQUISA
  const calcularCantidadRecibida = (data) => {
    let cantidadTot = 0;
    data.forEach((detalle) => {
      cantidadTot += detalle.Quantity;
    });
    return cantidadTot;
  };

  //SUMAR SUBTOTALES
  const sumarST = (data) => {
    let cantidadTot = 0;
    data.forEach((detalle) => {
      cantidadTot += detalle.SubTotal;
    });
    return cantidadTot;
  };

  //SUMAR DESCUENTOS
  const sumarDesc = (data) => {
    let cantidadTot = 0;
    data.forEach((detalle) => {
      cantidadTot += detalle.Descuento;
    });
    return cantidadTot;
  };

  //SUMAR DESCUENTOS
  const sumarIsv = (data) => {
    let cantidadTot = 0;
    data.forEach((detalle) => {
      cantidadTot += detalle.ISV;
    });
    return cantidadTot;
  };

  //REPORTE REQUISA 
  const generarPDFRequisa = async (data) => {
    const pdfUrls = []; // Almacenar las URLs generadas para cada PDF
  
    // Recorrer cada clave del objeto `data`    //06580 gte planta Luis Erazo
    const gtePlanta = await getFirmaPersonal('06580');
    const firmaFinanzas = await getFirmaPersonal('04007');
    const firmaNull = await getFirmaPersonal('111');

    const personal = await getUsuariosActivos();

    
    for (const [key, value] of Object.entries(data)) {
      let item = value[0];
      const cantidadTot = calcularCantidadRecibida(value);
      const sumST = sumarST(value);
      const sumDesc = sumarDesc(value);
      const sumIsv = sumarIsv(value);

      const totalResult = sumST + sumDesc + sumIsv

      // Buscar el usuario asociado a UsuarioPermiso4
      const usuarioEncontrado = personal.find(
        (persona) => persona.Usuario === item?.UsuarioPermiso4
      );
  
      // Obtener firma del Gte. Depto correspondiente
      const gteDepto = await getFirmaPersonal(usuarioEncontrado?.idPersonal?.toString());

      // Generar un docDefinition único por cada `IdPurchaseRequest`
      const docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [35, 90, 30, 40],

        header: function (currentPage, pageCount, pageSize) {
          return [
            {
              columns: [
                {
                  image: logoPPFBase64?.logo,
                  width: 150,
                  margin: [4, 10, 0, 0],
                },
                {
                  table: {
                    widths: [25, 160],
                    body: [
                      [
                        {
                          text: `${getLabel(
                            OrdenesComprasReporteLang,
                            "PR",
                            lenguaje
                          )}`,
                          colSpan: 2,
                          style: "titulo",
                          alignment: "center",
                          border: [true, true, true, true],
                        },
                        {},
                      ],
                      [
                        {
                          text: "No: ",
                          style: "titulo",
                          alignment: "left",
                          border: [true, true, true, true],
                        },
                        {
                          text: item?.PurchaseRequest, // Usar el número de requisición (clave del objeto)
                          style: "titulo",
                          alignment: "left",
                          border: [true, true, true, true],
                        },
                      ],
                    ],
                  },
                  layout: {
                    hLineWidth: function () {
                      return 0.5;
                    },
                    vLineWidth: function () {
                      return 0.5;
                    },
                    hLineColor: function () {
                      return "#000";
                    },
                    vLineColor: function () {
                      return "#000";
                    },
                  },
                  margin: [232, 30, 0, 0],
                },
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "prioridad",
                    lenguaje
                  )}: ${item?.Priority}`,
                  style: "titulo2",
                  margin: [-150, 75, 0, 0],
                },
              ],
            },
          ];
        },

        content: [
          //TABLA INFORMACION GENERAL
          {
            margin: [-10, 10, 0, 0],
            table: {
              widths: [63, "*", 63, "*", 63, "*"],
              body: [
                [
                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "fecha1",
                      lenguaje
                    )}`,
                    style: "tableHeader",
                  },
                  { text: `${item?.DateCreated}`, style: "tableInfo" },

                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "tipo",
                      lenguaje
                    )}`,
                    style: "tableHeader",
                  },
                  { text: `${item?.NombreTipo}`, style: "tableInfo" },

                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "proSG",
                      lenguaje
                    )}`,
                    style: "tableHeader",
                  },
                  {
                    text: `${item?.Proveedor?.slice(0, 22)}`,
                    style: "tableInfo",
                  },
                ],

                [
                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "area",
                      lenguaje
                    )}`,
                    style: "tableHeader",
                  },
                  { text: `${item?.Area}`, style: "tableInfo" },

                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "creadoNombre",
                      lenguaje
                    )}`,
                    style: "tableHeader",
                  },
                  { text: `${item?.UserCreate}`, style: "tableInfo" },

                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "solicita",
                      lenguaje
                    )}`,
                    style: "tableHeader",
                  },
                  { text: `${item?.ASolicita}`, style: "tableInfo" },
                ],
              ],
            },
          },

          //TABLA FIRMAS AUTORIZACIONES
          {
            margin: [-10, 10, 0, 0],
            table: {
              widths: ["*", "*", "*"],
              body: [
                [
                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "autorizaciones",
                      lenguaje
                    )}`,
                    style: "tableHeader",
                    colSpan: 3,
                  },

                  {},

                  {},
                ],

                [
                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "gteDepto",
                      lenguaje
                    )}`,
                    style: "tableHeaderCenter",
                  },

                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "finanzas",
                      lenguaje
                    )}`,
                    style: "tableHeaderCenter",
                  },

                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "gtePlanta",
                      lenguaje
                    )}`,
                    style: "tableHeaderCenter",
                  },
                ],

                [
                  {
                    image:item?.Permiso4 || gteDepto === undefined ? `data:image/png;base64,${gteDepto}` : `data:image/png;base64,${firmaNull}`,
                    width: 80,
                    height: 80,
                    alignment: "center",
                  },

                  {
                    image:item?.Permiso1 ? `data:image/png;base64,${firmaFinanzas}` : `data:image/png;base64,${firmaNull}`,
                    width: 80,
                    height: 80,
                    alignment: "center",
                  },

                  {
                    image:item?.Permiso3 ? `data:image/png;base64,${gtePlanta}` : `data:image/png;base64,${firmaNull}`,
                    width: 80,
                    height: 80,
                    alignment: "center",
                  }
                ],
              ],
            },
          },

          //TABLA DETALLES
          {
            margin:[-10,10,0,0],
            table:{
              widths:["11%", "*", "5%", "5%", "7%", "2%", "10%", "7%", "11%", "13%",],
              body:[
                //Encabezado
                [                  
                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"codigo",lenguaje)}`,
                    style:'tableHeader'
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"producto",lenguaje)}`,
                    style:'tableHeader'
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"cantidad",lenguaje)}`,
                    style:'tableHeaderCenter'
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"unidaPR",lenguaje)}`,
                    style:'tableHeaderCenter'
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"descuento",lenguaje)}`,
                    style:'tableHeaderCenter'
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"moneda",lenguaje)}`,
                    style:'tableHeaderCenter'
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"precio",lenguaje)}`,
                    style:'tableHeaderCenter'
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"isv",lenguaje)}`,
                    style:'tableHeaderCenter'
                  },

                  {
                    text:`SubTotal`,
                    style:'tableHeaderCenter'
                  },

                  {
                    text:`Total`,
                    style:'tableHeaderCenter'
                  },
                ],

                //Detalles
                ...value.map((e) =>
                  [
                    {
                      text:`${e.CodigoProducto}`,
                      style: "textBody2",
                      border: [false, false, false, false],
                    },
  
                    {
                      text:`${e.NombreProducto}`,
                      style: "textBody2",
                      border: [false, false, false, false],
                    },
  
                    {
                      text:formatNumberDecimal(`${e.Quantity || ''}`),
                      style: "textBody3",
                      border: [false, false, false, false],
                    },
  
                    {
                      text:`${e.UnitSimbol}`,
                      style: "textBody1",
                      border: [false, false, false, false],
                    },
  
                    {
                      text: e.Descuento !== 0 ? formatNumber3Dec(`${e.Descuento}`) : "",
                      style: "textBody3",
                      border: [false, false, false, false],
                    },
  
                    {
                      text:`${e.CurrencySymbol}`,
                      style: "textBody1",
                      border: [false, false, false, false],
                    },
  
                    {
                      text: e.Price !== 0 ? formatNumber3Dec(`${e.Price}`) : "",
                      style: "textBody3",
                      border: [false, false, false, false],
                    },
  
                    {
                      text: e.ISV !== 0 ? formatNumber3Dec(`${e.ISV}`) : "",
                      style: "textBody3",
                      border: [false, false, false, false],
                    },
  
                    {
                      text: formatNumber3Dec(`${e.SubTotal || ""}`),
                      text: e.SubTotal !== 0 ? formatNumber3Dec(`${e.SubTotal}`) : "",
                      style: "textBody3",
                      border: [false, false, false, false],
                    },
  
                    {
                      text: e.Total !== 0 ? formatNumber3Dec(`${e.Total}`) : "",
                      style: "textBody3",
                      border: [false, false, false, false],
                    },
                  ],
                ),
              ]
            }
          },

          //TABLA TOTALES
          {
            margin:[-10,3,0,0],
            table:{
              widths:["11%", "*", "7%", "5%", "7%", "2%", "10%", "12%", "6%", "13%",],
              body:[
                //SUBTOTAL
                [                  
                  {
                    text:`${value.length}`,
                    style:'textBody2',
                    border:[false, true, false, false]
                  },

                  {
                    text:``,
                    border:[false, true, false, false]
                  },

                  {
                    text: formatNumberDecimal(`${cantidadTot}`),
                    style:'textBody3',
                    border:[false, true, false, false]
                  },

                  {
                    text:``,
                    border:[false, true, false, false]
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"SubTotal",lenguaje)}`,
                    style:'textBody4',
                    colSpan:4,

                  },

                  {
                  },

                  {
                  },

                  {
                  },

                  {
                    text:`${item?.CurrencySymbol}`,
                    style:'textBody5',
                    border:[true, true, false, false]
                  },

                  {
                    text: formatNumber3Dec(sumST),
                    style:'textBody4',
                    border:[false, true, false, false]
                  },
                ],

                //DESCUENTO
                [     
                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"descuento",lenguaje)}`,
                    style:'textBody4',
                    colSpan:4,

                  },

                  {
                  },

                  {
                  },

                  {
                  },

                  {
                    text:`${item?.CurrencySymbol}`,
                    style:'textBody5',
                    border:[true, false, false, false]
                  },

                  {
                    text:sumDesc > 0 ? formatNumber3Dec(sumDesc) : '0.000',
                    style:'textBody4',
                    border:[false, false, false, false]
                  },
                ],

                //ISV
                [     
                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"isv",lenguaje)}`,
                    style:'textBody4',
                    colSpan:4,

                  },

                  {
                  },

                  {

                  },

                  {

                  },

                  {
                    text:`${item?.CurrencySymbol}`,
                    style:'textBody5',
                    border:[true, false, false, false]
                  },

                  {
                    text:sumIsv > 0 ? formatNumber3Dec(sumIsv) : '0.000',
                    style:'textBody4',
                    border:[false, false, false, false]
                  },
                ],

                //TOTAL
                [     
                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:``,
                    border:[false, false, false, false]
                  },

                  {
                    text:`${getLabel(OrdenesComprasReporteLang,"Total",lenguaje)}`,
                    style:'textBody4',
                    colSpan:4,

                  },

                  {
                  },

                  {

                  },

                  {

                  },

                  {
                    text:`${item?.CurrencySymbol}`,
                    style:'textBody5',
                    border:[true, false, false, false]
                  },

                  {
                    text:formatNumber3Dec(totalResult),
                    style:'textBody4',
                    border:[false, false, false, false]
                  },
                ],
              ]
            }
          },

          //TABLA COMENTARIO
          {
            margin: [-10, 10, 0, 0],
            table: {
              widths: ["10%","*"],
              body: [
                [
                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "comentarioPR",
                      lenguaje
                    )}`,
                    style: "tableHeader",
                  },
                  { text: `${item?.Comment}`,
                    style: "tableInfo",
                    border:[false, false, false , false]
                  },
                ],

                [
                  {
                    text:"",
                    border:[false, false, false , false]
                  },
                  {
                    text: `${getLabel(OrdenesComprasReporteLang,"fechaImpresion",lenguaje)} ${formatDateWithTime()}`,
                    style: "tableInfo",
                    border:[false, false, false , false],
                    margin:[270,40,0,0],
                  },
                ],
              ],
            },
          },
        ],

        styles: {
          header: {
            fontSize: 16,
            bold: true,
          },
          subheader: {
            fontSize: 12,
            bold: true,
          },
          tableHeader: {
            fontSize: 8,
            fillColor: "#e8f1f2",
          },
          tableHeaderCenter: {
            fontSize: 8,
            fillColor: "#e8f1f2",
            alignment: "center",
          },
          tableInfo: {
            fontSize: 8,
          },
          titulo: {
            fontSize: 14,
            alignment: "justify",
          },
          titulo2: {
            fontSize: 10,
            alignment: "justify",
          },
          textBody1: {
            fontSize: 7.5,
            alignment: "center",
          },
          textBody2: {
            fontSize: 7.5,
            alignment: "left",
          },
          textBody3: {
            fontSize: 7.5,
            alignment: "right",
          },
          textBody4: {
            fontSize: 8,
            alignment: "right",
          },
          textBody5: {
            fontSize: 8,
            alignment: "center",
          },
        },
      };

      // Crear PDF
      const doc = pdfMake.createPdf(docDefinition);
  
      // Obtener URL del PDF generado
      await new Promise((resolve) => {
        doc.getDataUrl((url) => {
          pdfUrls.push(url); // Agregar la URL al array
          resolve();
        });
      });
    }
  
    // Almacenar todas las URLs en el estado
    setPdfUrl2(pdfUrls);
  };

  //COMBINACION DE AMBOS REPORTES
  const combinarPDFs = async (pdf1, pdf2) => {
    const dataUnida = [...pdf1, ...pdf2];
  
    if (!dataUnida || dataUnida.length === 0) {
      return;
    }
  
    try {
      const pdfDoc = await PDFDocument.create();
  
      for (const pdfBase64 of dataUnida) {
        const pdfBytes = await fetch(pdfBase64).then((res) => res.arrayBuffer());
        const pdfDocTemp = await PDFDocument.load(pdfBytes);
        const pages = await pdfDoc.copyPages(pdfDocTemp, pdfDocTemp.getPageIndices());
        pages.forEach((page) => pdfDoc.addPage(page));
      }
  
      const mergedPdfBytes = await pdfDoc.save();
  
      // Crear un Blob y una URL temporal
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
  
      setPdfUrlCombinado(blobUrl);
    } catch (error) {
      console.error("Error al combinar los PDFs:", error);
    }
  };
  
  const onHideReporte = () => {
    setSelected([])
    getInfo();
    setShowReporte(false);
  };

  useEffect(() => {
    if (showReporte) {
      obtenerInformacion();
    }
  }, [showReporte]);

  useEffect(() => {
    combinarPDFs(pdfUrl, pdfUrl2);
  }, [pdfUrl, pdfUrl2]);

  return (
    <Dialog
      visible={showReporte}
      onHide={onHideReporte}
      style={{ width: "63vw", height: "85vh" }}
    >
      <Toast ref={toast} />

      {loading ? (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
        <Loader loading={loading} querySelector={"#Modal"} />
      </div>
      ):(
      <div id="Modal">
        {!loading && pdfUrlCombinado && (
          <iframe
            src={pdfUrlCombinado}
            style={{ width: "60vw", height: "75vh" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
      )}
    </Dialog>
  );
}

export default OrdenesComprasReporte
